import React, { Component } from "react";
import { Card, Icon, Button, message } from "antd";
import moment from "moment";
import F from "../../Functions";
import axios from "../../api";
import { Translate } from "react-translated";
import CustomAgGridTable from '../../Common-Table/CustomAgGridTable';
import '../../Common-Table/CustomAgGridTable.css';
import CustomHeader from '../../CommonHeader/CustomHeader';
import { ADMIN_DOWNLOAD_LAST_LOGIN, AGENCY_OWNER, AGENCY_STAFF, EA, LSP } from "../../utils/Constants";

class LastLogin extends Component {
  state = {
    loading: true,
    ea_users: [],
    lsp_users: [],
    efs_users: [],
  };
  componentDidMount = () => {
    this.loadStats();
  };

  componentDidUpdate = (prevProps) => {
    if (prevProps.location.state !== this.props.location.state) {
      this.loadStats();
    }
  };
  loadStats = (page) => {
    const ea_users = [];
    const lsp_users = [];
    const efs_users = [];
    this.setState({ loading: true });
    axios
      .get("/api/admin/last_login")
      .then((res) => {
        this.setState({ loading: false });
        for (var i = 0; i < res.data.length; i++) {
          res.data[i].last_login_days = moment(res.data[i].last_login).fromNow(
            true
          );
          if (res.data[i].user_type === EA || res.data[i].user_type == AGENCY_OWNER) {
            ea_users.push(res.data[i]);
          }
          if (res.data[i].user_type === LSP || res.data[i].user_type == AGENCY_STAFF) {
            lsp_users.push(res.data[i]);
          }
          if (res.data[i].user_type === "EFS") {
            efs_users.push(res.data[i]);
          }
        }
        this.setState({ ea_users, lsp_users, efs_users });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };
  // download = () => {
  //   this.setState({ loading: true });
  //   axios
  //     .get("/api/admin/download/last_login")
  //     .then((res) => {
  //       F.log(res);
  //       this.setState({ loading: false });
  //       if (res.data && res.data.token) {
  //         window.location =
  //           "/bfile/assets/files/last_login/" + res.data.token + ".csv";
  //       } else {
  //         message.error(F.translate(`Can't download the csv.`));
  //       }
  //     })
  //     .catch((error) => {
  //       F.log(error);
  //     });
  // };



  download = () => {
    this.setState({ loading: true });

    axios
      .get(ADMIN_DOWNLOAD_LAST_LOGIN, {
        responseType: "blob",
      })
      .then((res) => {
        this.setState({ loading: false });

        const blob = new Blob([res.data], { type: "text/csv;charset=utf-8;" });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "last_login.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        this.setState({ loading: false });
        F.log(error);
        message.error(F.translate(`Can't download the CSV.`));
      });
  };




  onGridReady_ea = (params) => {
    this.setState({
      gridApiEA: params.api,
      columnApiEA: params.columnApi
    });

    const savedState = localStorage.getItem("agGridColumnState");
    if (savedState) {
      params.columnApi.applyColumnState({
        state: JSON.parse(savedState),
        applyOrder: true,
      });
    }
  }


  onGridReady_lsp = (params) => {
    this.setState({
      gridApiLSP: params.api,
      columnApiLSP: params.columnApi
    });

    const savedState = localStorage.getItem("agGridColumnState");
    if (savedState) {
      params.columnApi.applyColumnState({
        state: JSON.parse(savedState),
        applyOrder: true,
      });
    }
  }


  onGridReady_efs = (params) => {
    this.setState({
      gridApiEFS: params.api,
      columnApiEFS: params.columnApi
    });

    const savedState = localStorage.getItem("agGridColumnState");
    if (savedState) {
      params.columnApi.applyColumnState({
        state: JSON.parse(savedState),
        applyOrder: true,
      });
    }
  }

  saveState_ea = (params) => {
    const state = params.columnApi.getColumnState();
    localStorage.setItem("agGridColumnState", JSON.stringify(state));
  }


  saveState_lsp = (params) => {
    const state = params.columnApi.getColumnState();
    localStorage.setItem("agGridColumnState", JSON.stringify(state));
  }


  saveState_efs = (params) => {
    const state = params.columnApi.getColumnState();
    localStorage.setItem("agGridColumnState", JSON.stringify(state));
  }



  render() {
    const { loading, ea_users, lsp_users, efs_users } = this.state;

    // Define AgGrid column definitions
    const columnDefs = [
      {
        headerClass: 'custom-ag-header',
        headerName: "Name",
        field: 'name',
        minWidth: 200,
        flex: 1,
        sortable: false,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['Name'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'name',
        }),
        cellRendererFramework: (params) => (
          <div>{params.data.name}</div>
        ),
      },
      {
        headerClass: 'custom-ag-header',
        headerName: "Email",
        field: 'email',
        minWidth: 200,
        flex: 1,
        sortable: false,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['Email'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'email',
        }),
        cellRendererFramework: (params) => (
          <div>{params.data.email}</div>
        ),
      },
      {
        headerClass: 'custom-ag-header',
        headerName: "Phone",
        field: 'phone',
        minWidth: 150,
        flex: 1,
        sortable: false,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['Phone'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'phone',
        }),
        cellRendererFramework: (params) => (
          <div>{params.data.phone}</div>
        ),
      },
      {
        headerClass: 'custom-ag-header',
        headerName: "Agency",
        field: 'agency_name',
        minWidth: 200,
        flex: 1,
        sortable: false,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['Agency'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'agency_name',
        }),
        cellRendererFramework: (params) => (
          <div>{params.data.agency_name}</div>
        ),
      },
      {
        headerClass: 'custom-ag-header',
        headerName: "Total B Files Created",
        field: 'total_bfiles',
        minWidth: 180,
        flex: 1,
        sortable: false,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['Total B Files Created'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'total_bfiles',
        }),
        cellRendererFramework: (params) => (
          <div>{params.data.total_bfiles}</div>
        ),
      },
      {
        headerClass: 'custom-ag-header',
        headerName: "Last Login",
        field: 'last_login',
        minWidth: 200,
        flex: 1,
        sortable: false,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['Last Login'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'last_login',
        }),
        cellRendererFramework: (params) => (
          <div>{params.data.last_login}</div>
        ),
      },
    ];

    const data_ea = [];
    for (let i = 0; i < ea_users.length; i++) {
      let user = ea_users[i];
      data_ea.push({
        key: i,
        name: user.first_name + " " + user.last_name,
        email: user.email,
        phone: user.phone,
        agency_name: user.agency_name,
        total_bfiles: user.bfile_count,
        last_login: user.last_login + " (" + user.last_login_days + ")",
      });
    }

    const data_lsp = [];
    for (let i = 0; i < lsp_users.length; i++) {
      let user = lsp_users[i];
      data_lsp.push({
        key: i,
        name: user.first_name + " " + user.last_name,
        email: user.email,
        phone: user.phone,
        agency_name: user.agency_name,
        total_bfiles: user.bfile_count,
        last_login: user.last_login + " (" + user.last_login_days + ")",
      });
    }

    const data_efs = [];
    for (let i = 0; i < efs_users.length; i++) {
      let user = efs_users[i];
      data_efs.push({
        key: i,
        name: user.first_name + " " + user.last_name,
        email: user.email,
        phone: user.phone,
        agency_name: user.agency_name,
        total_bfiles: user.bfile_count,
        last_login: user.last_login + " (" + user.last_login_days + ")",
      });
    }

    return (
      <div>
        <Card
          type="inner"
          title={
            <div style={{ paddingTop: 7 }}>
              <Icon
                type="area-chart"
                style={{ marginRight: 10, color: "#1890ff" }}
              />
              <Translate text={`Last Login`} />
            </div>
          }
          className="tableCard"
          loading={loading}
          extra={
            <Button onClick={() => this.download()}
              className="borderRadius-28"
            >
              <Translate text={`Download CSV`} />
            </Button>
          }
        >
          <Card bordered={false}>
            <h2>
              <Translate text={`Agency Owner`} />
            </h2>
          </Card>
          <CustomAgGridTable
            onGridReady={this.onGridReady_ea}
            onColumnMoved={this.saveState_ea}
            onSortChanged={this.saveState_ea}
            onFilterChanged={this.saveState_ea}
            rowDatas={data_ea}
            columnDefss={columnDefs}
          />
          <Card bordered={false}>
            <h2>
              <Translate text={`Agency Staff`} />
            </h2>
          </Card>
          <CustomAgGridTable
            onGridReady={this.onGridReady_lsp}
            onColumnMoved={this.saveState_lsp}
            onSortChanged={this.saveState_lsp}
            onFilterChanged={this.saveState_lsp}
            rowDatas={data_lsp}
            columnDefss={columnDefs}
          />
          <Card bordered={false}>
            <h2>
              <Translate text={`EFS`} />
            </h2>
          </Card>
          <CustomAgGridTable
            onGridReady={this.onGridReady_efs}
            onColumnMoved={this.saveState_efs}
            onSortChanged={this.saveState_efs}
            onFilterChanged={this.saveState_efs}
            rowDatas={data_efs}
            columnDefss={columnDefs}
          />
        </Card>
      </div>
    );
  }
}

export default LastLogin;



// WEBPACK FOOTER //
// ./src/scenes/SuperAdmin/last-login.js